import React, { useEffect, useState, useRef } from "react";
import ReactPaginate from "react-paginate";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getSearchPageLimit,
  normalizeSearchPage,
  SEARCH_RESULTS_PER_PAGE,
} from "./searchResultDisplay";

const groupSize = 200;
const perPage = SEARCH_RESULTS_PER_PAGE;

const PaginatedWrapper = ({ totalRecords, apiFunction, initialPage = 1, nextSearchAfter,sortValue }) => {
  const totalPages = getSearchPageLimit(totalRecords, perPage);

  const [currentPage, setCurrentPage] = useState(initialPage);
//   const [currentPageGroup, setCurrentPageGroup] = useState(Math.ceil(initialPage / groupSize));
  const [pageData, setPageData] = useState([]);
  const [searchAfterMap, setSearchAfterMap] = useState({});
  const fetchLock = useRef(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [pageReady, setPageReady] = useState(false);
  const navigate = useNavigate();
useEffect(() => {
  const allParams = {};
  for (const [key, value] of queryParams.entries()) {
    allParams[key] = value;
  }

  const pageFromURL = normalizeSearchPage(parseInt(allParams.page) || initialPage, totalRecords, perPage);
  setCurrentPage(pageFromURL);
  setPageReady(true); // allow rendering pagination after state set
  if (allParams.search_after) {
    try {
      const parsed = JSON.parse(allParams.search_after);
      if (Array.isArray(parsed)) {
        setSearchAfterMap((prev) => ({
          ...prev,
          [pageFromURL - 1]: parsed,
        }));
      }
    } catch (e) {
      console.error("Invalid search_after in URL");
    }
  }
  if (nextSearchAfter && Array.isArray(nextSearchAfter)) {
    setSearchAfterMap((prev) => ({
      ...prev,
      [pageFromURL]: nextSearchAfter,
    }));
  }
}, [totalRecords]);


  const currentPageGroup = Math.ceil(currentPage / groupSize);
const groupStartPage = (currentPageGroup - 1) * groupSize + 1;
// const groupEndPage = Math.min(groupStartPage + groupSize - 1, totalPages);
const groupEndPage = Math.min(groupStartPage + groupSize - 1, totalPages);

const relativePageIndex = currentPage - groupStartPage;

  const handlePageClick = async({ selected }) => {
    const absolutePage = normalizeSearchPage(groupStartPage + selected, totalRecords, perPage);
    setCurrentPage(absolutePage);
    const urlParams = new URLSearchParams(window.location.search);
    // Legacy params (no longer used) that can persist by being carried forward
    urlParams.delete("popular_property_type");
    urlParams.delete("more_property_type");
    

    const geometry = urlParams.get("geometry");
    if (document.getElementById("outer_properties")) {
      window.scroll({
        top: document.getElementById("outer_properties").offsetTop,
        left: 0,
        behavior: "smooth",
      });
    }
    urlParams.set("page", absolutePage);
    urlParams.set("geometry", geometry);
    const all_url_params = {};
    for (const [key, value] of urlParams.entries()) {
      all_url_params[key] = value;
    }
    const searchAfter = searchAfterMap[currentPage - 1] || null;
    all_url_params.search_after = searchAfter;
    // all_url_params.sort = sortValue;
      const result = await apiFunction(all_url_params, false,absolutePage);
navigate(
        `/search-property?${urlParams.toString()}`
      );
      if (result?.nextSearchAfter) {
        setSearchAfterMap((prev) => ({
          ...prev,
          [currentPage]: result.nextSearchAfter,
        }));
      }
  };

const handleDirectPageClick = async (pageNumber) => {
  const safePageNumber = normalizeSearchPage(pageNumber, totalRecords, perPage);
  setCurrentPage(safePageNumber);

  const urlParams = new URLSearchParams(window.location.search);
  // Legacy params (no longer used) that can persist by being carried forward
  urlParams.delete("popular_property_type");
  urlParams.delete("more_property_type");
  urlParams.set("page", safePageNumber);

  const all_url_params = {};
  for (const [key, value] of urlParams.entries()) {
    all_url_params[key] = value;
  }

  const searchAfter = searchAfterMap[safePageNumber - 1] || null;
  all_url_params.search_after = searchAfter;
// all_url_params.sort = sortValue;
  const result = await apiFunction(all_url_params, false, safePageNumber);

  if (result?.nextSearchAfter) {
    setSearchAfterMap((prev) => ({
      ...prev,
      [safePageNumber]: result.nextSearchAfter,
    }));
  }

  urlParams.set("search_after", JSON.stringify(searchAfter));
  navigate(`/search-property?${urlParams.toString()}`);
};
if(totalRecords <= 0 || totalRecords===NaN || totalRecords === 'NaN') {   
  return (
    <div className="no_search_data_found alert alert-danger">
      <h5>No Properties Found</h5>
      <p>There are no properties available for this search.</p>
    </div>
  );
}
  return (
    <div style={{ position: "sticky", bottom: 0}} className="new_pg">

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem", marginTop: "1rem",width:"100%" }}>
{groupStartPage > 1 && (
  <button
    onClick={() => handleDirectPageClick(groupStartPage - 1)}
    className="btn btn-secondary"
  >
    ⬅ {groupStartPage - 1}
  </button>
)}


{pageReady && (
        <ReactPaginate
          forcePage={relativePageIndex}
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={groupEndPage - groupStartPage + 1}
          previousLabel="<"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={false}
          pageLabelBuilder={(page) => groupStartPage + page - 1}
        />
        )}

 {groupEndPage < totalPages && (groupEndPage + 1 <= totalPages) && (
  <button
    onClick={() => handleDirectPageClick(groupEndPage + 1)}
    className="btn btn-secondary"
  >
    {groupEndPage + 1} ➡
  </button>
)}


      </div>
    </div>
  );
};

export default PaginatedWrapper;
